import React, { memo } from 'react';
import { CheckCircle2 } from 'lucide-react';
export function HeroSection() {
  const benefits = ['Significados claros de las 78 cartas, listos para consultar.', 'Métodos de tiradas desde nivel básico hasta lecturas complejas.', 'Estrategias para desarrollar tu intuición y no depender de la memoria.', 'Guía paso a paso para empezar a leer para otros con seguridad.', 'Plantillas y diarios de lectura para registrar tu progreso.', 'Enfoque terapéutico y evolutivo para lecturas profundas.'];
  return <section className="px-4 pt-4 pb-10 md:pt-8 md:pb-14" data-id="element-124">
      <div className="max-w-4xl mx-auto" data-id="element-125">
        <div className="flex items-center justify-center mb-4" data-id="element-126">
          <span className="px-4 py-1.5 text-sm font-medium text-brand-teal bg-brand-tealLight rounded-full border border-brand-teal/20" data-id="element-127">
            🔮 Conversion Élite
          </span>
        </div>

        <h1 className="mb-4 text-2xl font-bold leading-tight text-center md:text-3xl lg:text-4xl font-[Poppins,_sans-serif] text-[#E5E5E5]" data-id="element-128">
          Abrís, aplicás y leés: tarot{' '}
          <span className="text-violet-500" data-id="element-129">listo</span> para usar 🔮
        </h1>

        <div className="flex justify-center mb-2" data-id="element-130">
          <img src="https://cdn.magicpatterns.com/uploads/n3WGFbM5mYcMjvKQUvsqgN/aa8c533e-6088-4da3-8cd1-00a6fb74273c.png" alt="MegaPack Lectura de Tarot Kit Profesional — Cartas, guías digitales, bola de cristal y materiales descargables" className="w-full max-w-md md:max-w-lg pl-[80px] pr-[80px]" data-id="element-131" />
        </div>

        <p className="mb-8 text-center md:text-xl font-medium text-brand-dark/70 italic text-[16px]" data-id="element-132">
          Todo lo que necesitás para leer las cartas con confianza. Sin
          confusión. Sin improvisar. Sin miedo.
        </p>

        <div className="flex flex-col items-center text-center mb-8" data-id="element-133">
          <a href="#oferta" className="inline-flex items-center justify-center w-full md:w-auto px-12 py-5 text-xl font-semibold text-white transition-all duration-200 bg-brand-amber rounded-lg hover:bg-brand-amberHover hover:shadow-lg hover:-translate-y-0.5" data-id="element-134">
            Quiero el MegaPack 🔮
          </a>
          <p className="mt-3 text-sm text-brand-dark/60" data-id="element-135">
            PDF • Entrega automática al email • Garantía 7 días
          </p>
        </div>

        <p className="mb-8 text-center text-brand-dark/80 md:text-2xl text-[16px]" data-id="element-136">
          6 guías + 6 bonus en PDF. Descargables. Imprimibles.
        </p>

        <div className="flex items-center justify-center gap-3 mb-8" data-id="element-137">
          <div className="flex items-center gap-1" data-id="element-138">
            {[1, 2, 3, 4, 5].map(star => <svg key={star} className={`w-5 h-5 ${star <= 4 ? 'text-brand-amber' : 'text-brand-amber/40'}`} fill="currentColor" viewBox="0 0 20 20" data-id="element-139">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-140" />
              </svg>)}
            <span className="ml-1 text-lg font-bold text-brand-dark" data-id="element-141">
              4,9/5
            </span>
          </div>
          <span className="text-brand-dark/40" data-id="element-142">•</span>
          <p className="text-sm font-medium text-brand-dark/70" data-id="element-143">
            Más de 800 personas ya están leyendo con este método
          </p>
        </div>
      </div>
    </section>;
}